var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.is_mem_load
    ? _c("div", { staticClass: "memorandum_action" }, [
        _vm.empty_right
          ? _c(
              "div",
              { staticClass: "bd-callout bd-callout-info" },
              [
                _c(
                  "b-card-group",
                  { attrs: { deck: "" } },
                  [
                    _c(
                      "b-card",
                      {
                        staticClass: "text-center shadow-0",
                        attrs: {
                          "text-variant": "black",
                          title: "У Вас недостатньо прав для обробки документу",
                        },
                      },
                      [
                        _c("b-card-text", [
                          _vm._v(
                            "\n                    На даний момент Ви не можете обробляти документ.\n                "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cur_right === "init_user_restart"
          ? _c(
              "div",
              { staticClass: "adjust_block_work" },
              [
                _c(
                  "b-row",
                  [
                    _vm.hasBlackList
                      ? _c("b-col", { staticClass: "pt-3 mt-3 pb-3 mb-3" }, [
                          _vm._v(
                            "\n                Контрагент знаходиться в чорному списку, за роз'ясненнями звертатися до керівництва ФЕБ\n            "
                          ),
                        ])
                      : _c(
                          "b-col",
                          { attrs: { sm: "12" } },
                          [
                            _c("fileloader", {
                              key: "file_loader_mem_inside_work",
                              attrs: {
                                doc_type: "memorandum",
                                doc_id: -1,
                                trigger_load: _vm.file_triger,
                                can_del: true,
                              },
                            }),
                          ],
                          1
                        ),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.hasBlackList
                  ? _c(
                      "b-col",
                      {
                        staticClass: "pt-3 mt-3 pb-3 mb-3",
                        attrs: { sm: "3" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "fs-xl text-white",
                            attrs: {
                              disabled: _vm.is_locked_button,
                              block: "",
                              variant: "warning",
                              size: "xl",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.agree_action("init_user_restart")
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "fal fa-exclamation-triangle mr-1",
                            }),
                            _vm._v(
                              "\n                Перезапустити\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cur_right === "draft_init"
          ? _c(
              "div",
              { staticClass: "init_close button_margin" },
              [
                _c(
                  "b-row",
                  [
                    _vm.hasBlackList
                      ? _c("b-col", { staticClass: "pt-3 mt-3 pb-3 mb-3" }, [
                          _vm._v(
                            "\n                Контрагент знаходиться в чорному списку, за роз'ясненнями звертатися до керівництва ФЕБ\n            "
                          ),
                        ])
                      : _c(
                          "b-col",
                          {
                            staticClass: "pt-3 mt-3 pb-3 mb-3",
                            attrs: { sm: "3" },
                          },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  disabled: _vm.is_locked_button,
                                  block: "",
                                  variant: "success",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.agree_action("draft_init")
                                  },
                                },
                              },
                              [_vm._v("Запустити в роботу\n                ")]
                            ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cur_right === "init_user_close"
          ? _c(
              "div",
              { staticClass: "init_close" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("fileloader", {
                          key: "file_loader_mem",
                          attrs: {
                            doc_type: "memorandum",
                            doc_id: -1,
                            trigger_load: _vm.file_triger,
                            can_del: true,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("vue-editor", {
                          attrs: {
                            "editor-toolbar": _vm.editor_rules,
                            id: "d_ini_acc",
                          },
                          model: {
                            value: _vm.form.text,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "text", $$v)
                            },
                            expression: "form.text",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "pt-3 mt-3 pb-3 mb-3",
                        attrs: { sm: "3" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "lhx2",
                            attrs: {
                              disabled: _vm.is_locked_button,
                              block: "",
                              variant: "success",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.agree_action("init_close")
                              },
                            },
                          },
                          [_vm._v("В Архів\n                ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cur_right === "adjust_user"
          ? _c(
              "div",
              { staticClass: "adjust_block_work" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("fileloader", {
                          key: "file_loader_mem",
                          attrs: {
                            doc_type: "memorandum",
                            doc_id: -1,
                            trigger_load: _vm.file_triger,
                            can_del: true,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "mem_create_row" },
                  [
                    _c("b-col", { staticClass: "mh170", attrs: { sm: "3" } }, [
                      _vm.hasBlackList
                        ? _c(
                            "div",
                            { staticClass: "h-100 d-flex flex-column" },
                            [
                              _vm._v(
                                "\n                    Контрагент знаходиться в чорному списку, за роз'ясненнями звертатися до керівництва ФЕБ\n                "
                              ),
                            ]
                          )
                        : _c(
                            "div",
                            { staticClass: "h-100 d-flex flex-column" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mb-auto fs-xl lhx2",
                                  attrs: {
                                    disabled: _vm.is_locked_button,
                                    block: "",
                                    variant: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.agree_action("adjust")
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass: "fal fa-check mr-1",
                                  }),
                                  _vm._v(
                                    "\n                        Погоджую\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "lhx2 fs-xl",
                                  attrs: {
                                    disabled: _vm.is_locked_button,
                                    block: "",
                                    variant: "danger",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.dis_agree_action("adjust")
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "fal fa-exclamation-triangle mr-1",
                                  }),
                                  _vm._v(
                                    "\n                        Не погоджую\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "9" } },
                      [
                        _c("vue-editor", {
                          attrs: {
                            "editor-toolbar": _vm.editor_rules,
                            id: "result",
                          },
                          model: {
                            value: _vm.form.text,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "text", $$v)
                            },
                            expression: "form.text",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cur_right === "recipient_user"
          ? _c(
              "div",
              { staticClass: "recipient_block" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("fileloader", {
                          key: "file_loader_mem",
                          attrs: {
                            doc_type: "memorandum",
                            doc_id: -1,
                            trigger_load: _vm.file_triger,
                            can_del: true,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "mem_create_row" },
                  [
                    _c("b-col", { staticClass: "mh170", attrs: { sm: "3" } }, [
                      _c(
                        "div",
                        { staticClass: "h-100 d-flex flex-column" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mb-auto lhx2 fs-xl",
                              attrs: {
                                disabled: _vm.is_locked_button,
                                block: "",
                                variant: "success",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.agree_action("recipient")
                                },
                              },
                            },
                            [_vm._v("Затвердити\n                    ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "mb-auto lhx2 fs-xl",
                              attrs: {
                                disabled: _vm.is_locked_button,
                                block: "",
                                variant: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.edit_adjust()
                                },
                              },
                            },
                            [_vm._v("Додати погодження\n                    ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "lhx2 fs-xl",
                              attrs: {
                                disabled: _vm.is_locked_button,
                                block: "",
                                variant: "danger",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.dis_agree_action("recipient")
                                },
                              },
                            },
                            [_vm._v("Вiдхилити\n                    ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "9" } },
                      [
                        _c("vue-editor", {
                          attrs: {
                            "editor-toolbar": _vm.editor_rules,
                            id: "result_rec",
                          },
                          model: {
                            value: _vm.form.text,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "text", $$v)
                            },
                            expression: "form.text",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cur_right === "isp_user_accept"
          ? _c(
              "div",
              { staticClass: "isp_block_accept" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("fileloader", {
                          key: "file_loader_mem",
                          attrs: {
                            doc_type: "memorandum",
                            doc_id: -1,
                            trigger_load: _vm.file_triger,
                            can_del: true,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "mem_create_row" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "mh170", attrs: { sm: "3" } },
                      [
                        _c("date-picker", {
                          attrs: {
                            "value-type": "format",
                            lang: _vm.d_lang,
                            confirm: "",
                            "first-day-of-week": 1,
                          },
                          model: {
                            value: _vm.form.date_to,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "date_to", $$v)
                            },
                            expression: "form.date_to",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "add user",
                            on: { click: _vm.delegate },
                          },
                          [
                            _c("i", {
                              staticClass: "fa add_user fa-plus-square",
                              attrs: {
                                title: "",
                                "data-type": "delegate_users",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("Делегування")]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "users_delegate" }, [
                          _vm.form.users.length > 0
                            ? _c("div", { staticClass: "user_list u_list" }, [
                                _c(
                                  "div",
                                  { staticClass: "isp_list" },
                                  _vm._l(_vm.form.users, function (item) {
                                    return _c("user_block", {
                                      key: item.id,
                                      staticClass: "mb-1",
                                      attrs: { user: item },
                                    })
                                  }),
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "9" } },
                      [
                        _c("vue-editor", {
                          attrs: {
                            "editor-toolbar": _vm.editor_rules,
                            id: "result_isp_acc",
                          },
                          model: {
                            value: _vm.form.text,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "text", $$v)
                            },
                            expression: "form.text",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "mem_create_row" },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass:
                          "offset-lg-8 offset-xl-9 offset-sm-8 text-right pt-4",
                        attrs: { sm: "4", lg: "4", xl: "3", xs: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mb-auto fs-xl p-3 text-white mt-2",
                            attrs: {
                              disabled: _vm.is_locked_button,
                              block: "",
                              variant: "success",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.agree_action("isp_accept")
                              },
                            },
                          },
                          [_vm._v("Прийняв в роботу\n                ")]
                        ),
                        _vm._v(" "),
                        _vm.can_arch
                          ? _c(
                              "b-button",
                              {
                                staticClass: "fs-xl p-3",
                                attrs: {
                                  disabled: _vm.is_locked_button,
                                  block: "",
                                  variant: "danger",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.agree_action("store_isp_arch")
                                  },
                                },
                              },
                              [_vm._v("В архів\n                ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cur_right === "isp_user_work"
          ? _c(
              "div",
              { staticClass: "isp_block_work" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("fileloader", {
                          key: "file_loader_mem",
                          attrs: {
                            doc_type: "memorandum",
                            doc_id: -1,
                            trigger_load: _vm.file_triger,
                            can_del: true,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("vue-editor", {
                          attrs: {
                            "editor-toolbar": _vm.editor_rules,
                            id: "d_isp_acc",
                          },
                          model: {
                            value: _vm.form.text,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "text", $$v)
                            },
                            expression: "form.text",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "pt-3 mt-3 pb-3 mb-3",
                        attrs: { sm: "3" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "lhx2",
                            attrs: {
                              disabled: _vm.is_locked_button,
                              block: "",
                              variant: "success",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.agree_action("isp_work_end")
                              },
                            },
                          },
                          [_vm._v("Виконав\n                ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cur_right === "is_user_work_random"
          ? _c(
              "div",
              { staticClass: "isp_block_work" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("fileloader", {
                          key: "file_loader_mem",
                          attrs: {
                            doc_type: "memorandum",
                            doc_id: -1,
                            trigger_load: _vm.file_triger,
                            can_del: true,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("vue-editor", {
                          attrs: {
                            "editor-toolbar": _vm.editor_rules,
                            id: "d_isp_acc_r",
                          },
                          model: {
                            value: _vm.form.text,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "text", $$v)
                            },
                            expression: "form.text",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("h1", { staticClass: "title text-center pt-5 pb-5 mt-5" }, [
                  _vm._v(
                    "\n            Коли виконавець виконує службову, то повинен заповнити такі реквізити:\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm.random_adjust_data.length > 0
                  ? _c(
                      "b-row",
                      { staticClass: "fields_randm mt-2" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "6" } },
                          _vm._l(
                            this.random_adjust_data,
                            function (field, idx) {
                              return _c(
                                "div",
                                { staticClass: "isp_fields mt-3" },
                                [
                                  _c(
                                    "b-form-text",
                                    {
                                      attrs: {
                                        id: "help_" + field.type + field.id,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(field.name) +
                                          "\n                        "
                                      ),
                                      field.required == 1
                                        ? _c(
                                            "span",
                                            { staticClass: "color-danger-500" },
                                            [_vm._v(" * ")]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  field.type == "string_input"
                                    ? _c("b-form-input", {
                                        staticClass: "fs-xl",
                                        attrs: {
                                          type: "text",
                                          state: _vm.is_valid_field(field),
                                          id: field.type + field.id,
                                          size: "sm",
                                        },
                                        model: {
                                          value: field.value,
                                          callback: function ($$v) {
                                            _vm.$set(field, "value", $$v)
                                          },
                                          expression: "field.value",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  field.type == "date"
                                    ? _c("date-picker", {
                                        key: "dt_" + field.id,
                                        attrs: {
                                          "value-type": "format",
                                          lang: _vm.d_lang,
                                          "first-day-of-week": 1,
                                          confirm: "",
                                        },
                                        model: {
                                          value: field.value,
                                          callback: function ($$v) {
                                            _vm.$set(field, "value", $$v)
                                          },
                                          expression: "field.value",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "pt-3 mt-3 pb-3 mb-3",
                        attrs: { sm: "3" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "lhx2",
                            attrs: {
                              disabled: _vm.is_locked_button,
                              block: "",
                              variant: "success",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.agree_action("isp_random_work_end")
                              },
                            },
                          },
                          [_vm._v("Виконав\n                ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.delegate_operation
          ? _c(
              "div",
              { staticClass: "delegate_block_accept" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { sm: "12" } },
                      [
                        _c("fileloader", {
                          key: "file_loader_mem",
                          attrs: {
                            doc_type: "memorandum",
                            doc_id: -1,
                            trigger_load: _vm.file_triger,
                            can_del: true,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "3" } },
                      [
                        _vm.cur_right === "delegate_user_accept"
                          ? _c("date-picker", {
                              attrs: {
                                "value-type": "format",
                                lang: _vm.d_lang,
                                "first-day-of-week": 1,
                                confirm: "",
                              },
                              model: {
                                value: _vm.form.date_to,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "date_to", $$v)
                                },
                                expression: "form.date_to",
                              },
                            })
                          : _c(
                              "b-button",
                              {
                                staticClass: "lhx2",
                                attrs: {
                                  disabled: _vm.is_locked_button,
                                  block: "",
                                  variant: "success",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.agree_action("delegate_work_end")
                                  },
                                },
                              },
                              [_vm._v("Виконав\n                ")]
                            ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "9" } },
                      [
                        _c("vue-editor", {
                          attrs: {
                            "editor-toolbar": _vm.editor_rules,
                            id: "delegate_isp_acc",
                          },
                          model: {
                            value: _vm.form.text,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "text", $$v)
                            },
                            expression: "form.text",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.cur_right === "delegate_user_accept"
                  ? _c(
                      "b-row",
                      { staticClass: "mem_create_row" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "3" } },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "lhx2",
                                attrs: {
                                  disabled: _vm.is_locked_button,
                                  block: "",
                                  variant: "success",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.agree_action("delegate_accept")
                                  },
                                },
                              },
                              [_vm._v("Прийняв в роботу\n                ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.is_random_adjust_over
          ? _c(
              "div",
              { staticClass: "adjust_block_work" },
              [
                _c(
                  "b-row",
                  { staticClass: "mem_create_row" },
                  [
                    _c("b-col", { staticClass: "mh170", attrs: { sm: "3" } }, [
                      _c(
                        "div",
                        { staticClass: "h-100 d-flex flex-column" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mb-auto fs-xl lhx2",
                              attrs: {
                                disabled: _vm.is_locked_button,
                                block: "",
                                variant: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.agree_action("random_adjust_user")
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "fal fa-check mr-1" }),
                              _vm._v(
                                "\n                        Погоджую\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "lhx2 fs-xl",
                              attrs: {
                                disabled: _vm.is_locked_button,
                                block: "",
                                variant: "danger",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.dis_agree_action(
                                    "random_adjust_user"
                                  )
                                },
                              },
                            },
                            [_vm._v("Вiдхилити\n                    ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { sm: "9" } }, [
                      _c("div", { staticClass: "panel-tag" }, [
                        _vm._v(
                          "\n                    При погоджені, службова автоматично буде відправлена на затвердження. Якщо відмова - то автоматично буде запропонована іншим учасникам.\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "time_left" },
                        [
                          _c(
                            "flip-countdown",
                            {
                              attrs: {
                                labels: _vm.flip_label,
                                deadline: this.random_adjust_data.deadLine,
                                showDays: true,
                              },
                            },
                            [
                              _vm._v(
                                '\n                        @timeElapsed="timeElapsedHandler"\n                    '
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {},
                        [
                          _c("vue-editor", {
                            attrs: {
                              "editor-toolbar": _vm.editor_rules,
                              id: "resultы",
                            },
                            model: {
                              value: _vm.form.text,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "text", $$v)
                              },
                              expression: "form.text",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }